export const tabs = {
  properties: "Properties",
  template_plans: "Template Plans",
  library_plans: "Library Plans"
};
